import { apiGet } from '../standardApi';

export const apiGetMaintenance = async () => {
  const response = await apiGet(
    `/Maintenance/MaintenanceMessage/Web`,
    'application/json'
  );
  return response;
};
